











import { Component, Vue } from 'vue-property-decorator';
import SideNav from '../SideNav.vue';
import Editor from '../Editor.vue';
import MenuPanel from '../MenuPanel.vue';

@Component({
  components: {
    SideNav,
    Editor,
    MenuPanel,
  },
})
export default class extends Vue {
  noSeedText = '';

  seedTextLinks = `

## Links

[link text](http://dev.nodeca.com

 _ 

[link with title](http://nodeca.github.io/pica/demo/ "title text!")

Autoconverted link https://github.com/nodeca/pica (enable linkify to see)


## Images

![Minion](https://octodex.github.com/images/minion.png)
![Stormtroopocat](https://octodex.github.com/images/stormtroopocat.jpg "The Stormtroopocat")

Like links, Images also have a footnote style syntax

![Alt text][id]

With a reference later in the document defining the URL location:

[id]: https://octodex.github.com/images/dojocat.jpg  "The Dojocat"

`;

  seedTextCode = `

## Code

Inline \`code\`

Indented code

    // Some comments
    line 1 of code
    line 2 of code
    line 3 of code


Block code "fences"

\`\`\`
Sample text here...
\`\`\`

Syntax highlighting

\`\`\` js
var foo = function (bar) {
  return bar++;
};

console.log(foo(5));
\`\`\`
  `;

  seedLongText = `
# The Wind of Ways

Description datapath to data files to supply the data that will be passed into templates. Engiine to be used for processing templates. Handlebars is the default. Extension to be used for dest files.


## Blockquotes


> Blockquotes can also be nested...
>> ...by using additional greater-than signs right next to each other...
> > > ...or with spaces between arrows.


## Lists

Unordered

+ Create a list by starting a line with \`+\`, \`-\`, or \`*\`
+ Sub-lists are made by indenting 2 spaces:
  - Marker character change forces new list start:
    * Ac tristique libero volutpat at
    + Facilisis in pretium nisl aliquet
    - Nulla volutpat aliquam velit
+ Very easy!

Ordered

1. Lorem ipsum dolor sit amet
2. Consectetur adipiscing elit
3. Integer molestie lorem at massa


1. You can use sequential numbers...
1. ...or keep all the numbers as \`1.\`

Start numbering with offset:

57. foo
1. bar


## Code

Inline \`code\`

Indented code

    // Some comments
    line 1 of code
    line 2 of code
    line 3 of code


Block code "fences"

\`\`\`
Sample text here...
\`\`\`

Syntax highlighting

\`\`\` js
var foo = function (bar) {
  return bar++;
};

console.log(foo(5));
\`\`\`

## Tables

| Option | Description |
| ------ | ----------- |
| data   | path to data files to supply the data that will be passed into templates. |
| engine | engine to be used for processing templates. Handlebars is the default. |
| ext    | extension to be used for dest files. |

Right aligned columns

| Option | Description |
| ------:| -----------:|
| data   | path to data files to supply the data that will be passed into templates. |
| engine | engine to be used for processing templates. Handlebars is the default. |
| ext    | extension to be used for dest files. |


## Links

[link text](http://dev.nodeca.com)

[link with title](http://nodeca.github.io/pica/demo/ "title text!")

Autoconverted link https://github.com/nodeca/pica (enable linkify to see)


## Images

![Minion](https://octodex.github.com/images/minion.png)
![Stormtroopocat](https://octodex.github.com/images/stormtroopocat.jpg "The Stormtroopocat")

Like links, Images also have a footnote style syntax

![Alt text][id]

With a reference later in the document defining the URL location:

[id]: https://octodex.github.com/images/dojocat.jpg  "The Dojocat"


## Plugins

The killer feature of \`markdown-it\` is very effective support of
[syntax plugins](https://www.npmjs.org/browse/keyword/markdown-it-plugin).


### [Emojies](https://github.com/markdown-it/markdown-it-emoji)

> Classic markup: :wink: :crush: :cry: :tear: :laughing: :yum:
>
> Shortcuts (emoticons): :-) :-( 8-) ;)

see [how to change output](https://github.com/markdown-it/markdown-it-emoji#change-output) with twemoji.


### [Subscript](https://github.com/markdown-it/markdown-it-sub) / [Superscript](https://github.com/markdown-it/markdown-it-sup)

- 19^th^
- H~2~O


### [\\<ins>](https://github.com/markdown-it/markdown-it-ins)

++Inserted text++


### [\\<mark>](https://github.com/markdown-it/markdown-it-mark)

==Marked text==


### [Footnotes](https://github.com/markdown-it/markdown-it-footnote)

Footnote 1 link[^first].

Footnote 2 link[^second].

Inline footnote^[Text of inline footnote] definition.

Duplicated footnote reference[^second].

[^first]: Footnote **can have markup**

    and multiple paragraphs.

[^second]: Footnote text.


### [Definition lists](https://github.com/markdown-it/markdown-it-deflist)

Term 1

:   Definition 1
with lazy continuation.

Term 2 with *inline markup*

:   Definition 2

        { some code, part of Definition 2 }

    Third paragraph of definition 2.

_Compact style:_

Term 1
  ~ Definition 1

Term 2
  ~ Definition 2a
  ~ Definition 2b


### [Abbreviations](https://github.com/markdown-it/markdown-it-abbr)

This is HTML abbreviation example.

It converts "HTML", but keep intact partial entries like "xxxHTMLyyy" and so on.

*[HTML]: Hyper Text Markup Language

### [Custom containers](https://github.com/markdown-it/markdown-it-container)

::: warning
*here be dragons*
:::
  `;

  marketingText = `

# Welcome to Markably!

---
> **You are using an early access build of Markably**. We currently only fully support chrome. Some issues are expected on other browsers. Mobile support is still a work in progress too.
> \n
> There is still a long list of bugs, missing features, and performance issues that we are working on. 
> \n
> If you would like to send us some feedback drop me a mail at matthewmullin01@gmail.com - or even better - guide our next additions by checking out our [roadmap here](https://matthewmullin01.typeform.com/to/hKAUBn7X)
---

Hi there! This is a test markdown file. Edit me all you want. Once you are ready to create a new file just delete me. Or if you would prefer to import an existing markdown file click the **menu on the top right**.

## What are we all about?

Our aim is simple. Be the go to cross platform markdown editor for everyday use. Our *early access* includes a mostly functions web application, and our desktop and mobile ports are not far behind. 

## Features

Our number one priority it to make sure we have a solid baseline markdown support. All basic markdown support is functional. Some extended markdown features are still in the works and will be added in the near future as we are still in *early access*.

### Inline Marks

We have full support for inline *italics*, **bold**, ~~strikethrough~~ and \`code\`

### Code Blocks

Use triple backticks to create a code block/code fence. We have syntax highlighting for most popular coding languages.

\`\`\`
// Javascript

const message = "This is my text.";
function test() {
  console.log(message + "notice the blank line before this function?");
}
\`\`\`

\`\`\`
# Python

if num < 0:
   print("Enter a positive number")
else:
   sum = 0
   # use while loop to iterate until zero
   while(num > 0):
       sum += num
       num -= 1
   print("The sum is", sum)
\`\`\`

### Image Support *(beta)*

*This is still a work in progress. Expect improvements over the next few updates.*

![Caption](https://images.unsplash.com/photo-1582789810681-98443a5aa87c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=3910&q=80)

## Roadmap

We would love if you took a moment to provide some feedback and add to our [roadmap here](https://matthewmullin01.typeform.com/to/hKAUBn7X). Any ideas, feature requests or bug reports would be much appreciated.

* ~~Basic Markdown Syntax~~
* ~~Image Support~~
* ~~Webapp~~
* Desktop Apps - MacOS, Windows, Linux - ***in progress***
* Table Support - ***in progress***
* Online Cloud Sync
* Realtime Collaboration
* Mobile Apps - Android and iOS

## Cheat Sheet

* Headings - \`# Heading\`
* Bold - \`**bolded**\`
* Italics - \`*italics*\`
* Strikethrough - \`~~Strikethrough~~\`
* Horizontal Line - \`---\`
* Blockquotes - \`> Blockquotes\`
* Code - \`\`inline\`\` or  \` \`\`\` block  \`\`\`  \`
* List - \`* List item\`
* Numbered List - \`1. List item\`
* Link - \`[link text](http://matthewmullin.io)\`
* Image - \`![Minion](https://octodex.github.com/images/minion.png)\`

---
## Contact

Send your **feedback [here](https://matthewmullin01.typeform.com/to/hKAUBn7X)**.

Drop me an email at **matthewmullin01@gmail.com**.


---

`;

  seedText = localStorage.editorContentHtml ? localStorage.editorContentHtml : process.env.IS_TAURI ? '' : this.marketingText;
}
